import { createSvgComponent } from "../../icon/createSvgComponent";
import SnackbarWarning from "@core/__generated__/icon/figma/Snackbar/warning.svg";
export default createSvgComponent(SnackbarWarning);